module.exports = __webpack_public_path__ + "static/media/maintenance_ab9b0b3.98def0a9.hex";